<!--
   Created by qing on 2020/8/20
   Des: 
-->
<template>
	<div
		class="app-forms-container"
		v-if="!pageError"
	>
		<el-dialog
			:visible="dialogVisible"
			class="close-icon-disable app-des-dialog"
			title="应用说明"
		>
			<header
				class="app-des-dialog__header"
				slot="title"
			>
				<h3>
					应用说明
				</h3>
			</header>
			<div class="app-des-dialog__content">
				<div
					class="app-des-dialog__content-tips"
					v-show="appDesConfig.readDetailConfig[0].introHtml && appDesConfig.readDetailConfig[0].introHtml.length"
				>
					<div
						v-if="appDesConfig.readConfigType==='MUTI'"
						class="title"
					>
						<div>{{appDesConfig.readDetailConfig[appDesStepEditDataIndex].stepShowText}}</div>
					</div>
					<div class="tips">
						<p>{{appDesConfig.readDetailConfig[appDesStepEditDataIndex].alertText}}</p>
						<span>剩余时间：{{readTime}}s</span>
					</div>
					<div class="ql-editor-read">
						<div
							class="ql-editor-read-show"
							v-html="appDesConfig.readDetailConfig[appDesStepEditDataIndex].introHtml"
						>
						</div>
					</div>
					<div
						v-if="readTime===0 && isScrollBottom"
						class="dialog-read-finish-btns"
					>
						<el-button
							v-if="!isReadFinish"
							@click="onClickNextStep"
							type="primary"
							size="small"
						>下一步
						</el-button>
						<el-button
							v-if="isReadFinish"
							@click="onClickFinishRead"
							type="primary"
							size="small"
						>完成阅读
						</el-button>
					</div>
				</div>
				<div
					v-show="!appDesConfig.readDetailConfig[0].introHtml || !appDesConfig.readDetailConfig[0].introHtml.length"
					class="empty-container"
				>
					<p>
						暂无应用说明，请点击右上角进行编辑
					</p>
				</div>
			</div>
		</el-dialog>
		<template v-if="!loading">
			<div
				class="tree-forms"
				v-if="!showFormType"
			>
				<el-tree
					ref="formTree"
					:key="treeKey"
					:data="treeForms"
					node-key="contentId"
					default-expand-all
					draggable
					highlight-current
					:allow-drag="allowDrag"
					:render-content="renderFormTreeContent"
					@node-click="handleFormTreeNodeClick"
				>
				</el-tree>
			</div>
			<!--九宫格-->
			<div
				class="grid-view-container"
				v-else
			>
				<div
					class="grid-view-item"
					v-for="item in gridViewForms"
					v-if="item.children && item.children.length"
					:key="item.contentId"
				>
					<div class="grid-view-title">
						{{item.name}}
					</div>
					<div class="form-container">
						<div class="form-box">
							<div
								class="form-item"
								v-for="form in item.children"
								:key="form.relateId"
								:ref="`formItem${item.contentId}${form.relateId}`"
								@click="handleFormTreeNodeClick(form)"
								@mousedown.stop="formItemMousedown(item, form)"
							>

								<div class="form-icon">
									<i
										v-if="form.contentType === FORM_TYPE_DASHBOARD"
										style="color: #FF464C;"
										:class="form.contentIcon ? `${form.contentIcon} item-icon` : 'iconfont icon-dynamic'"
									>
									</i>
									<i
										v-if="form.contentType === FORM_TYPE_FORM"
										style="color: #05A971;"
										:class="form.contentIcon ? `${form.contentIcon} item-icon` : 'iconfont icon-document'"
									>
									</i>
								</div>
								<div class="form-name">
									{{form.name}}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<van-action-sheet
				class="select-form-action-sheet"
				v-model="selectFormConfig.visible"
				get-container="body"
			>
				<div
					class="select-form-content"
					v-if="selectFormConfig.visible"
				>
					<div class="header">
						<div class="title">
							<div>{{selectFormConfig.form.name}}</div>
						</div>
						<div class="handle">
							<div class="handle-item">
								<van-icon
									v-if="!isStar"
									name="star-o"
									@click="starForm"
									color="#FF8107"
									size="16"
								>
								</van-icon>
								<van-icon
									v-else
									name="star"
									@click="cancelStarForm"
									color="#FF8107"
									size="16"
								>
								</van-icon>
								<div>星标</div>
							</div>

						</div>
					</div>
					<div class="handle-container">
						<div
							class="item"
							@click="onClickFlowManage"
						>
							<!-- <van-icon name="smile-comment-o" /> -->
							<div class="number">
								{{selectFormConfig.flowCount}}
							</div>
							<div class="title">
								流程管理
							</div>
						</div>
						<div
							class="item"
							@click="onClickFormData"
						>
							<!-- <van-icon name="chart-trending-o" /> -->
							<div class="number">
								{{selectFormConfig.dataCount}}
							</div>
							<div class="title">
								管理数据
							</div>
						</div>
					</div>
					<van-button
						v-if="selectFormConfig.form.canTypeData"
						color="#4260FA"
						class="bottom-btn"
						@click="onClickFillForm"
					>
						填写数据
					</van-button>
				</div>
			</van-action-sheet>

		</template>

		<div
			style="background-color: #ffffff; height: 100%;"
			v-else
		>
			<van-skeleton
				style="padding-top: 20px;"
				title
				:row="16"
			>
			</van-skeleton>
		</div>
	</div>
	<div
		v-else
		class="error-page"
	>
		<img
			:src="`${$BASE_PATH}/fetch/image?id=358184796255420417.png`"
			alt=""
		>
		<p>链接错误</p>
		<van-button
			type="primary"
			size="small"
			@click="reloadPage"
		>
			点击重试
		</van-button>
	</div>
</template>

<script>
	import {
		FORM_TYPE_FORM,
		FORM_TYPE_DIRECTORY,
		FORM_TYPE_DASHBOARD
	} from "../../RyForm/types";

	export default {
		inject: ['reload'],
		data() {
			return {
				FORM_TYPE_FORM,
				FORM_TYPE_DASHBOARD,
				loading: true,
				aEle: null,
				appId: this.$route.query.appId,
				showFormType: Number(this.$route.query.showFormType),
				treeForms: [],
				treeKey: Math.random(),
				// 九宫格数据源
				gridViewForms: [],
				starList: [],
				selectFormConfig: {
					visible: false,
					form: null,
					flowCount: 0,
					dataCount: 0,
				},
				pageError: false,
				dialogVisible: false,
				appDesConfig: {
					needRead: 'NO', // 当前用户是否需要阅读
					openReadHandle: 'NO', //是否开启阅读后可操作应用
					allNeedRead: 'YES', //所有人必须可读 当所有人需要阅读关闭后,选人才显示,两个是互斥的
					adminJumpRead: 'YES', //管理员是否跳过阅读
					needReadChoose: {
						depart: [], //部门
						role: [], //角色
						member: [], //人员
						dynamic: [], // 动态
						external: [], // 外部联系人
						externalTag: [] // 外部联系人标签
					},
					readConfigType: 'ONE', //ONE 单条 MUTI 多条
					readDetailConfig: [ // 应用说明详细信息，单条时默认选择第一项
						{
							key: '', // 自动生成key
							stepShowText: '', //步骤条显示内容
							readTime: 0, // 阅读时间，单位为秒
							alertText: '', //提示内容
							introHtml: "",
						},
						{
							key: '', // 如果没有，自动生成key
							stepShowText: '', //步骤条显示内容
							readTime: 0, // 阅读时间，单位为秒
							alertText: '', //提示内容
							introHtml: ''
						},
					],
					readMap: {
						isReadFinish: 'NO'
					}
				},
				readTime: 0,
				appDesStepEditDataIndex: 0,
				isScrollBottom: false,
			}
		},
		created() {
			if (!this.aEle) this.aEle = document.createElement('a')
			this.fetchStarFormList()
			this.$store.dispatch('actionFetchCustomForms', {
					appId: this.appId,
					showFormType: this.showFormType
				})
				.then(res => {
					const formMap = {}

					res.map(form => {
						if (form.parentId === 'root') {
							if (form.contentType === FORM_TYPE_FORM ||
								form.contentType === FORM_TYPE_DASHBOARD ||
								form.contentType === FORM_TYPE_DIRECTORY) {
								this.treeForms.push(form)
							}
						}
						if (form.contentType === FORM_TYPE_DIRECTORY) {
							form.children = formMap[form.relateId] = []
						}
						return form
					}).forEach(form => {
						if (formMap[form.parentId]) {
							formMap[form.parentId].push(form)
						}
					})

					const rootForms = []
					this.treeForms.forEach(item => {
						if (item.contentType === FORM_TYPE_DIRECTORY && item.contentId !== 'star') {
							this.gridViewForms.push(item)
						} else if (item.contentId !== 'star') {
							rootForms.push(item)
						}
					})
					this.gridViewForms.push({
						name: '其他',
						contentId: 'root',
						children: rootForms
					})
				})
				.catch(err => {
					console.log(err)
					this.pageError = true
				})
				.finally(() => {
					this.loading = false
				})
			this.fetchAppDes(this.appId)
		},
		computed: {
			isStar() {
				const form = this.starList.filter(item => item.relateId === this.selectFormConfig.form.relateId)[0]
				return !!form
			},
			isReadFinish() {
				if (this.readTime === 0 && this.appDesConfig.readConfigType === 'ONE') {
					return true
				}
				if (this.appDesConfig.readDetailConfig.length - 1 === this.appDesStepEditDataIndex && this.readTime ===
					0) {
					return true
				}
				return false
			}
		},
		methods: {
			fetchAppDes(appId) {
				this.$store.dispatch('actionFetchAPPDes', appId)
					.then(resultObject => {
						console.log('resultObject', resultObject)
						this.appDesConfig.needRead = resultObject.needRead
						this.appDesConfig.openReadHandle = resultObject.openReadHandle
						this.appDesConfig.allNeedRead = resultObject.allNeedRead
						this.appDesConfig.adminJumpRead = resultObject.adminJumpRead
						this.appDesConfig.needReadChoose = JSON.parse(JSON.stringify(resultObject.needReadChoose))
						this.appDesConfig.readConfigType = resultObject.readConfigType
						this.appDesConfig.readMap = JSON.parse(JSON.stringify(resultObject.readMap))
						this.appDesConfig.readDetailConfig = JSON.parse(JSON.stringify(resultObject.readDetailConfig))
						if (this.appDesConfig.readDetailConfig.length === 0) {
							this.appDesConfig.readDetailConfig.push({
								key: this.$RyUuid(), // 自动生成key
								stepShowText: '', //步骤条显示内容
								readTime: 0, // 阅读时间，单位为秒
								alertText: '', //提示内容
								introHtml: "",
							})
							this.appDesConfig.readDetailConfig.push({
								key: this.$RyUuid(), // 自动生成key
								stepShowText: '', //步骤条显示内容
								readTime: 0, // 阅读时间，单位为秒
								alertText: '', //提示内容
								introHtml: "",
							})
						}
						//判断是否需要弹dialog
						if (this.appDesConfig.needRead === 'YES' && this.appDesConfig.readMap.isReadFinish !== 'YES') {
							this.dialogVisible = true
							// 定时器
							this.setTimer()
							this.$nextTick(() => {
								console.log(this.dialogVisible)
								const ele = document.querySelector('.ql-editor-read-show')
								console.log(ele)
								document.querySelector('.ql-editor-read').addEventListener('scroll', () => {
									this.calculateScrollToBottom()
								})
							})
						}
					}).catch(() => console.error)
			},
			onClickNextStep() {
				this.appDesStepEditDataIndex += 1
				this.isScrollBottom = false
				this.setTimer()
				this.calculateScrollToBottom()
			},
			calculateScrollToBottom() {
				this.$nextTick(() => {
					const container = document.querySelector('.ql-editor-read')
					const ele = document.querySelector('.ql-editor-read-show')
					console.log('container', container.getBoundingClientRect().bottom)
					console.log('ele', ele.getBoundingClientRect().bottom)
					if (container.getBoundingClientRect().bottom > ele.getBoundingClientRect().bottom) {
						this.isScrollBottom = true
					}
					if (ele.getBoundingClientRect().height < 250) {
						this.isScrollBottom = true
					}
				})
			},
			setTimer() {
				// 需要阅读时打开计时
				if (this.appDesConfig.needRead === "YES" && this.appDesConfig.readMap.isReadFinish !== 'YES') {
					this.readTime = this.appDesConfig.readDetailConfig[this.appDesStepEditDataIndex].readTime
					const timer = setInterval(() => {
						this.readTime--
						if (this.readTime === 0) {
							this.calculateScrollToBottom()
							clearInterval(timer)
						}
					}, 1000)
				}
			},
			onClickFinishRead() {
				// 阅读完成请求
				this.$store.dispatch('finishRead', {
						appId: this.appId,
						readMap: {
							isReadFinish: 'YES'
						}
					})
					.then(resultObject => {

					}).catch(() => console.error)
				this.dialogVisible = false
			},
			// 判断节点能否被拖拽
			allowDrag(draggingNode) {
				return false;
			},
			// 渲染树
			renderFormTreeContent(h, {
				node,
				data,
				store
			}) {
				const create = this.$createElement

				let iconClass = ""
				let titleClass = ""
				if (data.contentType === FORM_TYPE_DIRECTORY) {
					iconClass = node.expanded && node.childNodes.length > 0 ?
						"el-icon-folder-opened folder-icon" : "el-icon-folder folder-icon"
				} else if (data.contentType === FORM_TYPE_DASHBOARD) {
					iconClass = data.contentIcon ? `${data.contentIcon} dashboard-icon item-icon` :
						'iconfont icon-dynamic dashboard-icon item-icon'
					titleClass = "form-title"
				} else {
					iconClass = data.contentIcon ? `${data.contentIcon} form-icon item-icon` :
						"iconfont icon-document form-icon item-icon"
					titleClass = "form-title"
				}
				const icon = create("i", {
					staticClass: iconClass
				})
				const title = create("span", {
					staticClass: titleClass
				}, [icon, data.name])
				return create("div", {
					staticClass: "form-tree-item"
				}, [title])
			},
			// 点击表单
			handleFormTreeNodeClick(data) {

				if (data.contentType === FORM_TYPE_FORM) {
					this.selectFormConfig.form = data
					if (data.canViewData) {
						// 有查看数据权限
						this.$store.dispatch('actionFormHandleNumber', {
							appId: this.appId,
							formId: data.relateId
						}).then(res => {
							this.selectFormConfig.flowCount = res.waitHandleCount
							this.selectFormConfig.dataCount = res.formDataCount
						}).catch(console.error)
						this.selectFormConfig.visible = true
					} else {
						// 没有查看数据权限，直接填写表单
						this.onClickFillForm()
					}

				} else if (data.contentType === FORM_TYPE_DASHBOARD) {
					const toast = this.$toast.loading({
						message: '加载中...'
					})
					this.$store.dispatch('actionNodeSave', {
							companyId: this.$store.getters.currentCompanyId,
							userId: this.$store.getters.userId,
							appId: this.appId,
							dashboardId: data.relateId,
							token: this.$store.state.token,
							env: this.$store.getters.env
						})
						.then(res => {
							let dashUrl = ''
							if (process.env.NODE_ENV === 'production') {
								dashUrl = `${location.origin}${this.$DS_BASE_PATH}/#/dashboard?key=${res.nodeKey}`
							} else {
								dashUrl = `https://node.dev.161.54188.online/miniappds/#/dashboard?key=${res.nodeKey}`
							}
							// 存store数据
							sessionStorage.setItem('store', JSON.stringify(this.$store.state))
							// location.replace(dashUrl)
							if (this.aEle) {
								this.aEle.href = dashUrl
								this.aEle.target = '_self'
								this.aEle.click()
							}
						})
						.catch(console.error)
						.finally(() => {
							toast.clear()
						})
				}
			},

			// 星标表单
			starForm() {
				this.$store.dispatch('actionFormStar', {
						formId: this.selectFormConfig.form.relateId
					})
					.then(res => {
						this.$toast.success('设置成功')
						this.starList.unshift(this.selectFormConfig.form)
						if (!this.showFormType && this.starList.length === 1) {
							this.treeForms.unshift({
								name: '星标表单',
								contentId: 'star',
								contentType: FORM_TYPE_DIRECTORY,
								children: this.starList
							})
							this.treeKey = Math.random()
						}
					})
					.catch(console.error)
			},
			// 取消星标表单
			cancelStarForm() {
				this.$store.dispatch('actionFormStarCancel', {
						formId: this.selectFormConfig.form.relateId
					})
					.then(res => {
						this.$toast.success('设置成功')
						let index = -1
						this.starList.forEach((item, idx) => {
							if (item.relateId === this.selectFormConfig.form.relateId) {
								index = idx
							}
						})
						if (index > -1) this.starList.splice(index, 1)
						if (!this.showFormType && !this.starList.length) {
							const star = this.treeForms.filter(item => item.contentId === 'star')[0]
							if (star && this.$refs.formTree) {
								this.$refs.formTree.remove(star)
							}
						}
					})
					.catch(console.error)
			},
			// 星标表单list
			fetchStarFormList() {
				this.$store.dispatch('actionFormStarList')
					.then(resultObject => {

						resultObject.forEach(formObj => {
							if (this.appId === formObj.appId) {
								this.starList.push({
									relateId: formObj.formId,
									formId: formObj.formId,
									name: formObj.formName,
									formName: formObj.formName,
									contentType: FORM_TYPE_FORM,
									...formObj
								})
							}
						})
						if (this.starList.length) {
							this.treeForms.unshift({
								name: '星标表单',
								contentId: 'star',
								contentType: FORM_TYPE_DIRECTORY,
								children: this.starList
							})
						}

						this.gridViewForms.unshift({
							name: '星标表单',
							contentId: 'star',
							children: this.starList
						})
					})
					.catch(console.error)
			},

			formItemMousedown(item, form) {
				let ele = this.$refs[`formItem${item.contentId}${form.relateId}`][0]
				if (ele) {
					ele.style.transition = 'transform 0.1s ease 0s'
					ele.style.transform = 'scale(0.9)'
					setTimeout(() => {
						ele.style.transition = 'transform 0.1s ease 0s'
						ele.style.transform = 'scale(1)'
					}, 100)
				}
			},
			// 填写表单
			onClickFillForm() {
				const toast = this.$toast.loading({
					message: '加载中...'
				})
				this.$store.dispatch('reqNodeSave', {
						companyId: this.$store.getters.currentCompanyId,
						userId: this.$store.getters.userId,
						appId: this.appId,
						formId: this.selectFormConfig.form.relateId,
						token: this.$store.state.token,
						userInfo: this.$store.getters.userInfo
					})
					.then(res => {
						this.$router.push({
							name: 'formInput',
							query: {
								key: res.nodeKey
							}
						})
					})
					.catch(err => {
						console.error(err)
					})
					.finally(() => {
						toast.clear()
					})
			},
			// 流程管理
			onClickFlowManage() {
				this.$router.push({
					name: 'formFlowManage',
					query: {
						appId: this.appId,
						formId: this.selectFormConfig.form.relateId,
					}
				})
			},
			// 表单数据
			onClickFormData() {
				const toast = this.$toast.loading({
					message: '加载中...'
				})
				this.$store.dispatch('reqNodeSave', {
						companyId: this.$store.getters.currentCompanyId,
						userId: this.$store.getters.userId,
						appId: this.appId,
						formId: this.selectFormConfig.form.relateId,
						token: this.$store.state.token,
						userInfo: this.$store.getters.userInfo
					})
					.then(res => {
						this.$router.push({
							name: 'formData',
							query: {
								key: res.nodeKey
							}
						})
					})
					.catch(err => {
						console.error(err)
					})
					.finally(() => {
						toast.clear()
					})
			},
			reloadPage() {
				this.reload()
			}
		}
	}
</script>

<style lang="less">
	.app-forms-container {
		height: 100%;
		overflow: auto;
		box-sizing: border-box;
		-webkit-overflow-scrolling: touch;
		background-color: #fff;

		.tree-forms {
			padding: 10px;

			.el-tree-node {

				.el-tree-node__content {
					height: 40px !important;
					/*border-bottom: 1px solid #e6e6e6;*/
				}

				.form-tree-item {
					flex: 1;
					display: flex;
					align-items: center;
					justify-content: space-between;
					font-size: 14px;
					padding-right: 8px;
					height: 40px;

					.form-title {
						white-space: nowrap;
						text-overflow: ellipsis;
						overflow: hidden;
						word-wrap: break-word;
						max-width: 180px;
						height: 40px;

						>.item-icon {
							margin-left: 2px;
							font-size: 22px;
						}
					}

					span {
						display: flex;
						align-items: center;
					}

					.form-icon {
						color: #05A971;
						font-size: 18px;
						width: 24px;
						height: 18px;
						margin-left: 4px;
						margin-right: 4px;
					}

					.event-form-icon {
						color: #02A3D6;
					}

					.dashboard-icon {
						color: #FF464C;
						font-size: 18px;
						width: 24px;
						height: 18px;
						margin-left: 4px;
						margin-right: 4px;
					}

					.aggregation-icon {
						color: #7444A8;
						font-size: 18px;
						width: 24px;
						height: 18px;
						margin-left: 4px;
						margin-right: 4px;
					}

					.folder-icon {
						color: #F5D769;
						font-size: 18px;
						width: 24px;
						height: 18px;
						margin-left: 4px;
						margin-right: 4px;
					}

					.form-tree-item-setting,
					.form-tree-item-star {
						color: #19be6b;
						display: none;

						&:hover {
							color: #19be6b;
						}
					}

					.form-tree-item-link {
						margin: 0;
					}
				}

				.el-tree-node__content {
					height: 50px;

					.el-tree-node__expand-icon {
						font-size: 20px;
						padding: 0;
					}

					&:hover {
						>.form-tree-item {

							.form-tree-item-setting,
							.form-tree-item-star {
								display: inline-block;
							}
						}
					}
				}

				&.is-current {
					>.el-tree-node__content {
						.form-tree-item {

							.form-title {
								color: #73a5da;
							}

							.form-tree-item-setting,
							.form-tree-item-star {
								display: inline-block;
							}
						}
					}
				}
			}
		}

		.grid-view-container {

			.grid-view-item {
				margin: 20px;
				border-radius: 8px;
				// background-color: #fff;

				.grid-view-title {
					height: 40px;
					line-height: 40px;
					background-color: transparent;
					color: #000;
					font-size: 16px;
				}

				.form-container {
					
					position: relative;

					> :nth-child(3n) {
						border-right: none !important;
					}
					.form-box{
						display: flex;
						flex-wrap: wrap;
						margin: 0 -10px;
						border-left: 1px solid #F4F4F4;
						border-top: 1px solid #F4F4F4;
					}
					.form-item {
						width: calc(100% / 3);
						text-align: center;
						border-right: 1px solid #F4F4F4;
						border-bottom: 1px solid #F4F4F4;
						background-color: #fff;
						box-sizing: border-box;

						.form-icon {
							width: 100%;
							height: 54px;
							line-height: 54px;
							font-size: 40px !important;
							text-align: center;

							i {
								color: #ffffff;
								font-size: 25px !important;
								border-radius: 5px;
								padding: 12px;
							}

							>.item-icon {
								font-size: 28px !important;
							}
						}

						.form-name {
							width: 100%;
							overflow: hidden;
							text-overflow: ellipsis;
							display: -webkit-box;
							line-clamp: 2;
							-webkit-box-orient: vertical;
							font-size: 14px;
							margin-bottom: 4px;
							padding: 4px 0;
							color: #333333;
						}
					}
				}
			}
		}

	}

	.select-form-action-sheet {

		.select-form-content {
			width: 100%;
			height: 100%;
			background-color: #fff;
			padding: 20px 16px 16px;
			display: flex;
			flex-direction: column;
			align-items: center;

			.header {
				width: 100%;

				.title {
					width: calc(100% - 120px);
					float: left;
					height: 46px;
					margin-bottom: 26px;

					div {
						text-overflow: ellipsis;
						white-space: nowrap;
						overflow: hidden;
						height: 28px;
						line-height: 28px;
						font-size: 20px;
						color: #000;
						font-weight: 700;
						margin-bottom: 4px;
					}
				}

				.handle {
					width: 120px;
					float: right;
					padding-left: 10px;
					box-sizing: border-box;

					.handle-item {
						width: 54px;
						height: 30px;
						float: right;
						display: flex;
						align-items: center;

						.van-icon {
							font-size: 22px;
							margin: 0 3px 4px 0;
							color: #4A66FA;
						}

						>div {
							font-size: 12px;
						}
					}
				}
			}

			.handle-container {
				width: 100%;
				display: flex;
				justify-content: space-around;

				.item {
					display: flex;
					align-items: center;
					flex-direction: column;
					margin-bottom: 12px;
					background-color: #F6F6F6;
					width: 113px;
					height: 75px;

					.number {
						font-size: 27px;
						font-weight: 700;
						margin: 12px 0 8px 0;
					}
					

					.title {
						height: 14px;
						line-height: 14px;
						font-size: 12px;
						color: rgba(43, 52, 65, .6);
						text-align: center;
					}
				}
			}

			.bottom-btn {
				width: 90%;
				margin-top: 12px;
				height: 37px;
				border-radius: 6px;
			}
		}
		
	}
	.scrollBar(@width: 10px, @bg: rgba(0, 0, 0, 0.3), @shadow: inset 6px rgba(0, 0, 0, 0.2)) {
		&::-webkit-scrollbar {
			width: @width;
			height: @width;
		}

		&::-webkit-scrollbar-thumb {
			border-radius: 8px;
			background: @bg;
			box-shadow: @shadow;
		}
	}


	.app-des-dialog {
		display: flex;
		align-items: center;
		justify-content: center;

		.el-dialog {
			width: 80%;
			min-height: 480px;
			margin: 0 !important;

			.app-des-dialog__header {
				display: flex;
				justify-content: space-between;
				align-items: center;
				border-bottom: 1px solid #eaeaea;

				.app-des-dialog__edit-btn {
					margin-right: 50px;
					color: #757575;
				}

				> :nth-child(2) {
					margin-right: 50px;
				}
			}

			.el-dialog__body {
				.scrollBar(6px, rgba(0, 0, 0, 0.2));
				/*overflow: auto;*/
				/*position: absolute;*/
				/*top: 90px;*/
				/*bottom: 20px;*/
				/*left: 0;*/
				/*right: 0;*/


				.app-des-dialog__content {

					.app-des-container {
						margin-bottom: 20px;

						img {
							max-width: 100%;
						}
					}

					.empty-container {
						width: 100%;
						height: 100%;
						display: flex;
						justify-content: center;
						align-items: center;
						color: red;
					}
				}

				.quill-editor {
					overflow: auto;
					position: absolute;
					top: 0;
					bottom: 0;
					left: 0;
					right: 0;
					padding: 0 20px;

					.ql-container {

						height: 90%;

					}
				}
			}
		}
	}

	.ql-editor-read {
		padding: 12px 20px;
		height: 250px;
		overflow-y: auto;

		img {
			max-width: 100%;
		}

	}

	.app-des-dialog__content-tips {
		.title {
			padding: 12px 15px;
		}

		.tips {
			padding: 12px 15px;
		}
	}

	.dialog-read-finish-btns {
		margin-top: 20px;
		display: flex;
		justify-content: center;
	}
</style>
